import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCaracteresNumeros]'
})
export class CaracteresNumerosDirective {

  constructor(private ctrl: NgControl) { }
  @HostListener('input', ['$event'])
  onKeyUp(event: Event) {
    const inputOriginal = (event.target as HTMLInputElement).value;
    this.ctrl.control.setValue(this.transform(inputOriginal));
    event.stopPropagation();
  }
  transform(value: string): string {
    const valueReturn = value
      .replace(/[^A-Za-z0-9\s]/g, '');
    return valueReturn;
  }

}
